export default {

  dev: {
    host: "http://admin.3adiaoding.test/api",
    category_id: "1",
  },
  pro: {
    host: "https://backend.177xz.com/api",
    category_id: "1",
  }
}



// WEBPACK FOOTER //
// ./src/env.js